import { apiGetAnnexedParamsByType } from '../api/Argentia/endpoints/annexedParams/annexedParams.api'
import { AnnexedParamsModel } from '../api/Argentia/endpoints/annexedParams/model/annexedParams'
import { EnumTipoParamAnexo } from '../api/oData/enums/enumTipoParamAnexo'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../helpers/serviceResponseHelper'
import { ServiceResponse } from '../model/serviceResponse'

export const getAnnexedParamsByType = async (
  paramType: EnumTipoParamAnexo,
  commodity?: number,
  country?: number
): Promise<ServiceResponse<AnnexedParamsModel[] | undefined>> => {
  return await apiGetAnnexedParamsByType(paramType, commodity, country)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
